<script>
import InputCount from "./InputCount.vue";
import {priceFormat} from "./helper";

export default {
  name: "LineService",
  components: {InputCount},
  props: {
    modelValue: {
      type: [Number, Object],
      default: 0
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 10
    },
    name: {
      type: String,
      required: true,
    },
    nameDescription: {
      type: String,
    },
    description: {
      type: String,
    },
    price: {
      type: Number,
      default: 0
    },
    showPrice: {
      type: Boolean,
      default: true
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  methods: {
    priceFormat(price) {
      return priceFormat(price);
    }
  }
}
</script>

<template>
  <div class="tw-flex tw-flex-col tw-gap-4 tw-rounded-3xl tw-border tw-border-solid tw-border-[#e8dcc8] tw-bg-white tw-p-4 lg:tw-flex-row lg:tw-items-center lg:tw-justify-between lg:tw-gap-6 lg:tw-p-5" :class="{'tw-opacity-70': disabled}">
    <div class="lg:tw-max-w-[360px]">
      <div class="tw-text-gray-700 tw-font-medium tw-leading-snug">
        {{name}} <span v-if="nameDescription" class="tw-text-sm tw-text-gray-500">{{nameDescription}}</span>
      </div>
      <div v-if="description" class="tw-mt-1 tw-text-sm tw-leading-relaxed tw-text-gray-500 tw-font-normal">{{description}}</div>
    </div>
    <div class="tw-flex tw-items-center tw-justify-between tw-gap-4 lg:tw-ml-auto">
      <input-count v-model="modelValue.value" :min="min" :max="max" :required="required" :disabled="disabled"/>
      <div v-if="showPrice" class="tw-min-w-[110px] tw-text-right">
      <div v-if="price" class="tw-font-medium">{{priceFormat(price)}}</div>
      <div v-else class="tw-font-medium">бесплатно</div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
